// NOTE: NSAI-6258 — the palette an organization's badge is coloured from. Eight
// hues rather than a token each, because the badge's job is to be TOLD APART
// from the badge above it, which the theme's own colours cannot do: they are
// one hue by design. The hues are evenly spread around the wheel so two
// organizations next to each other are unlikely to land on neighbours.
//
// Every entry is a solid fill carrying white text, checked at 4.5:1 against
// #FFFFFF, so the initials stay legible in both themes without a per-theme
// variant — the badge is its own surface, not a tint of the page behind it.
export const ORGANIZATION_AVATAR_PALETTE = [
  "#4F5BD5", // indigo
  "#C2410C", // orange
  "#047857", // emerald
  "#B91C1C", // red
  "#6D28D9", // violet
  "#0E7490", // cyan
  "#A16207", // amber
  "#BE185D", // pink
] as const;

export type TOrganizationAvatarColor =
  (typeof ORGANIZATION_AVATAR_PALETTE)[number];
